import * as React from 'react';

import 'components/tabs/tabs-section/tabs-section.scss';
import '../../tabs/tile-standard-tabs.scss';
import './tile-standard-loading-tabs.scss';

const TileStandardLoadingTabs = (): JSX.Element => (
  <div className="tile-standard-tabs">
    <ul className="tabs-section">
      <li className="tabs-section__item tile-standard-tabs__tab tabs-section__item--size-normal">
        <div className="tile-standard-loading-tabs__item" />
      </li>
      <li className="tabs-section__item tile-standard-tabs__tab tabs-section__item--size-normal">
        <div className="tile-standard-loading-tabs__item" />
      </li>
      <li className="tabs-section__item tile-standard-tabs__tab tabs-section__item--size-normal">
        <div className="tile-standard-loading-tabs__item" />
      </li>
    </ul>
  </div>
);

export default TileStandardLoadingTabs;
